import React, { useEffect } from 'react';
import { Tile, Button } from 'mesh-component-library';
import { useDispatch } from 'react-redux';
import Constants from '../../../env/constants';
import useClaimData from '../../../redux/hooks/useClaimData';
import { useClaimInfoSelector } from '../../../redux/hooks/useClaimInfoSelector';
import { useRouteProps } from '../../../redux/hooks/useRouteProps';
import AssetRadioButton from '../../../components/buttons/AssetRadio';
import { setLoadingModalFlagAction } from '../../../redux/reducers/actions';

const AssetSelectionPage: React.FC = () => {
    const claim = useClaimData();
    const setSelectedClaimInfo = useClaimInfoSelector();
    const dispatch = useDispatch();
    const { text, onClick } = useRouteProps();
    const isClaimInfoSelectionButtonDisabled = claim.selectedClaimInfoIndex === null;

    useEffect(() => {
        dispatch(setLoadingModalFlagAction(false));
    }, [dispatch]);

    return (
        <div data-testid="asset-page-body" className="page-body">
            <section data-testid="asset-selection-page" className="body-section">
                {claim.claimInfoLinkList.map(
                    ({ make, model, year, streetAddress, city, state, link }: ClaimInfoLink, index: number) => (
                        <Tile
                            className="validation-form"
                            borderLeft="gray"
                            key={`selection-tile-${link}`}
                            hasPortal
                            style={{ paddingTop: 0 }}
                        >
                            <div data-testid="asset-card">
                                <Tile.Body hasBorder={index !== claim.claimInfoLinkList.length - 1}>
                                    <div data-testid="asset-radio-button">
                                        <AssetRadioButton
                                            claimInfoString={
                                                !streetAddress
                                                    ? `${year} ${make} ${model}`
                                                    : `${streetAddress} ${city}, ${state}`
                                            }
                                            link={link}
                                            /* eslint-disable-next-line react/no-array-index-key */
                                            key={`${index}`}
                                            claimInfoIndex={index}
                                            selectedClaimInfoIndex={claim.selectedClaimInfoIndex}
                                            onChange={setSelectedClaimInfo}
                                        />
                                    </div>
                                </Tile.Body>
                            </div>
                        </Tile>
                    ),
                )}
                <div data-testid="help-text-button-container" className="help-text-button-container">
                    <div
                        data-testid="asset-selection-help-text"
                        className="help-text"
                        style={{ visibility: 'visible' }}
                    >
                        {Constants.helpMessage}
                    </div>
                    <div data-testid="asset-button-container">
                        <Button
                            hasUpgrade
                            variant="information"
                            onClick={onClick}
                            className="validation-button"
                            disabled={isClaimInfoSelectionButtonDisabled}
                        >
                            {text}
                        </Button>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AssetSelectionPage;
